import { render, staticRenderFns } from "./YjsDocsAttach.vue?vue&type=template&id=285a1cd8"
import script from "./YjsDocsAttach.vue?vue&type=script&lang=js"
export * from "./YjsDocsAttach.vue?vue&type=script&lang=js"
import style0 from "./YjsDocsAttach.vue?vue&type=style&index=0&id=285a1cd8&prod&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports